import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import WebsterContent from "./WebsterPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/webster/pumps" component={WebsterContent} />
          <Route path="/suppliers/webster">
            <Redirect to="/suppliers/webster/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
